import {IIdioma} from "../../entities/catalogos/IIdioma";

export const SET_IDIOMA = "SET_IDIOMA";

interface ISetIdioma {
    type: typeof SET_IDIOMA
    idioma: IIdioma
}

export type IdiomaActionTypes = ISetIdioma
